import React from 'react';
import {useTranslation} from 'react-i18next';

import {Text} from '@phonectas/unifon-ui-kit';

interface VismaDocumentTypeProps {
	type: string | null;
}

const VismaDocumentType: React.FC<VismaDocumentTypeProps> = ({type}) => {
	const [t] = useTranslation();
	const reminderMatch = type && type.match(/^T(?:\[(\d+)\]|(\d+))$/);

	let placeholderText = '';

	if (type === 'IN') {
		placeholderText = t('Invoice');
	} else if (type === 'CR') {
		placeholderText = t('Credit note');
	} else if (type === 'IR') {
		placeholderText = t('Interest note');
	} else if (reminderMatch) {
		const number = reminderMatch[1] || reminderMatch[2];
		placeholderText = t('Reminder number {{number}}', {number});
	} else {
		placeholderText = t('Unknown or no document type');
	}

	return (
		<span>
			<Text variant="body1">
				{placeholderText}
			</Text>
		</span>
	);
}

export default VismaDocumentType;
